import React from 'react';
import { PaymentMethod } from '../utils/constants.ts';

export const ConfirmOrderModalBody = (paymentMethod: PaymentMethod) => {
  const hour = new Date().getHours();
  const isToday = hour < 8;

  return (
    <>
      <span>
        Estás a punto de confirmar tu pedido que será entregado{' '}
        {isToday ? 'durante el día de ' : 'el día de '}
      </span>
      <strong>{isToday ? 'HOY' : 'MAÑANA'}</strong>
      {paymentMethod === PaymentMethod.TRANSFER ||
      paymentMethod === PaymentMethod.MERCADOPAGO ? (
        <>
          <br />
          <br />
          <span>
            Por favor enviar el comprobante de pago por WhatsApp para que se
            despache su pedido.
          </span>
        </>
      ) : null}
    </>
  );
};
